import { NewsDO } from "./news.data"
import { newsService } from "./news.service"
import { capitalized, formatDate } from "../core/formatters/index"
import { CtaComponent } from "../core/components/cta/cta.component"

import "./newslist.style.scss"
import { DateOptionSet } from "../core/models/date"
import { i18n } from "../core/services/i18n-service"

export class NewsListComponent extends HTMLElement {
    private news: NewsDO[] = []
    private query: string | null = ""
    private tokens: string | null = ""
    private newsTitle: string | null = ""
    private k: string | null = null
    private minScore: string | null = null

    constructor() {
        super()
        this.className = 'tbw-news-list'
    }

    connectedCallback() {
        this.setNewsAttributes()
        this.init()
    }

    async init() {
        this.news = await this.load()
        if (this.news.length === 0) { this.createCTA(); return }
        this.news.sort((a, b) => new Date(b.published).getTime() - new Date(a.published).getTime())

        this.createNewsList()
    }

    async load() {
        const res = await newsService.load(this.query, this.tokens, this.newsTitle, this.k, this.minScore)
        return res
    }

    async createCTA() {
        const cta = new CtaComponent()
        this.appendChild(cta)
        cta.show()
    }

    setNewsAttributes() {
        this.query = this.getAttribute('data-news-query') ?? null
        this.tokens = this.getAttribute('data-news-tokens') ?? null
        this.newsTitle = this.getAttribute('data-news-title') ?? null
        this.k = this.getAttribute('k') ?? null
        this.minScore = this.getAttribute('min-score') ?? null
    }

    private createNewsList() {
        const newsList = document.createElement('div')
        newsList.className = 'news-list'
        this.appendChild(newsList)

        this.news.slice(0, 10).forEach(news => {
            const newsItem = document.createElement('div')
            newsItem.className = 'news-item'
            newsItem.innerHTML = `
                <a href='${news.link}' target='_blank' class='news-item-content'>
                    <p class='news-item-title'>${news.title}</p>
                    <div class='news-item-metadata'>
                        <div class='news-item-date'>${this.createTimeIcon().outerHTML}<p class="caption2">${formatDate(new Date(news.published), i18n.getLanguage() === 'en' ? DateOptionSet.dateEN : DateOptionSet.dateFR)}</p></div>    
                        ${news.source_logo ? `<img src='${news.source_logo}' alt='${news.title}' class='news-item-logo'>` : '<div class="news-item-logo"></div>'}
                    </div>
                </a>
            `
            newsList.appendChild(newsItem)
        })
    }

    private createTimeIcon(): SVGSVGElement {
        const timeIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg")
        timeIcon.setAttribute("width", "12")
        timeIcon.setAttribute("height", "12")
        timeIcon.setAttribute("viewBox", "0 0 16 17")
        timeIcon.setAttribute("fill", "none")

        timeIcon.innerHTML = `
            <path d="M5.24023 2.19952V4.16474" stroke="var(--midnight-blue)" stroke-width="0.74211" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.4814 2.19952V4.16474" stroke="var(--midnight-blue)" stroke-width="0.74211" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.29297 6.84399H13.4292" stroke="var(--midnight-blue)" stroke-width="1.07194" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.7561 6.45749V12.0256C13.7561 13.9908 12.7735 15.301 10.4808 15.301H5.24021C2.94745 15.301 1.96484 13.9908 1.96484 12.0256V6.45749C1.96484 4.49227 2.94745 3.18213 5.24021 3.18213H10.4808C12.7735 3.18213 13.7561 4.49227 13.7561 6.45749Z" stroke="var(--midnight-blue)" stroke-width="1.07194" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        `
        return timeIcon
    }
}